<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="String($t('user_page.department_members'))")
    b-container(fluid)
      .context
        department-user-grid(:pk="pk")

    .modal-footer
      b-button(size="sm" variant="secondary" @click="visible = false" pill) {{$t('submit')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import DepartmentUserGrid from "./gridDepartmentUser.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    pk: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    Dialogs,
    DepartmentUserGrid,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style lang="scss" scoped></style>
